
<template>
  <aside
    class="
      sidenav
      bg-white
      navbar navbar-vertical navbar-expand-xs
      border-0
      fixed-start
    "
    id="sidenav-main"
    :class="[isCollapsed ? 'collapsed' : '', isOpenMobile ? 'open' : '']"
  >
    <div class="sidenav-header">
      <i
        class="
          fas
          fa-times
          p-3
          cursor-pointer
          text-secondary
          opacity-5
          position-absolute
          end-0
          top-0
          d-none d-xl-none
        "
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <a class="navbar-brand m-0" href="javascript:;" target="_blank">
        <img
          src="https://djangompg.blob.core.windows.net/media/images/mansfield-energy-logo.png"
          class="navbar-brand-img h-100"
        />
      </a>
    </div>
    <hr class="horizontal dark mt-0" />
    <div class="collapse navbar-collapse w-auto" id="sidenav-collapse-main">
      <ul class="navbar-nav">
        <!-- <li class="nav-item">
          <router-link to="/" class="nav-link">
            <div
              class="
                icon icon-shape icon-sm
                border-radius-md
                text-center
                me-2
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <i
                class="fas fa-tachometer-alt text-primary text-sm opacity-10"
              ></i>
            </div>
            <span class="nav-link-text ms-1">Dashboard</span>
          </router-link>
        </li> -->
        <!-- <li class="nav-item mt-3">
          <h6
            class="
              ps-4
              ms-2
              text-uppercase text-xs
              font-weight-bolder
              opacity-6
            "
          >
            OPERATIONS
          </h6>
        </li> -->
        <li class="nav-item">
          <router-link class="nav-link" to="/mpg/opportunities">
            <div
              class="
                icon icon-shape icon-sm
                border-radius-md
                text-center
                me-2
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <i class="fas fa-star text-warning text-sm opacity-10"></i>
            </div>
            <span class="nav-link-text ms-1">Opportunities</span>
          </router-link>
        </li>
        <!-- <li class="nav-item">
          <router-link class="nav-link" to="/activities/">
            <div
              class="
                icon icon-shape icon-sm
                border-radius-md
                text-center
                me-2
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <i
                class="far fa-calendar-alt text-success text-sm opacity-10"
              ></i>
            </div>
            <span class="nav-link-text ms-1">Activities</span>
          </router-link>
        </li> -->
        <!-- <li class="nav-item mt-3">
          <h6
            class="
              ps-4
              ms-2
              text-uppercase text-xs
              font-weight-bolder
              opacity-6
            "
          >
            MASTER DATA
          </h6>
        </li> -->
        <!-- <li class="nav-item">
          <router-link class="nav-link" to="/mpg/inbox">
            <div
              class="
                icon icon-shape icon-sm
                border-radius-md
                text-center
                me-2
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <i class="fas fa-envelope text-primary text-sm opacity-10"></i>
            </div>
            <span class="nav-link-text ms-1">Inbox</span>
          </router-link>
        </li> -->
        <li class="nav-item">
          <router-link class="nav-link" to="/mpg/organizations">
            <div
              class="
                icon icon-shape icon-sm
                border-radius-md
                text-center
                me-2
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <i class="fas fa-sitemap text-primary text-sm opacity-10"></i>
            </div>
            <span class="nav-link-text ms-1">Organizations</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/mpg/contacts">
            <div
              class="
                icon icon-shape icon-sm
                border-radius-md
                text-center
                me-2
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <i class="fas fa-address-book text-info text-sm opacity-10"></i>
            </div>
            <span class="nav-link-text ms-1">Contacts</span>
          </router-link>
        </li>
       <li class="nav-item">
          <router-link class="nav-link" to="/mpg/addresses">
            <div
              class="
                icon icon-shape icon-sm
                border-radius-md
                text-center
                me-2
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <i class="fas fa-map-marker-alt text-danger text-sm opacity-10"></i>
            </div>
            <span class="nav-link-text ms-1">Addresses</span>
          </router-link>
        </li>
         <!-- <li class="nav-item mt-3">
          <h6
            class="
              ps-4
              ms-2
              text-uppercase text-xs
              font-weight-bolder
              opacity-6
            "
          >
            SETTINGS
          </h6>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/mpg/tags">
            <div
              class="
                icon icon-shape icon-sm
                border-radius-md
                text-center
                me-2
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <i class="fas fa-tags text-success text-sm opacity-10"></i>
            </div>
            <span class="nav-link-text ms-1">Tags</span>
          </router-link>
        </li> -->
      </ul>
    </div>
    <div class="sidenav-footer mx-3"></div>
  </aside>
</template>

<script>
import { bus } from '../main'

export default {
  data () {
    return {
      isCollapsed: false,
      isOpenMobile: false
    }
  },
  created () {
    bus.$on('toggleMenu', (data) => {
      this.isCollapsed = !this.isCollapsed
    })
    bus.$on('toggleMenuMobile', (data) => {
      this.isOpenMobile = !this.isOpenMobile
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LeftNavbar.vue